<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Pensioen en uitkeringen
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Onder 'Pensioen en andere uitkeringen' vallen de volgende Nederlandse uitkeringen:
                <li class="list">pensioen en wachtgeld</li>
                <li class="list">een ontslaguitkering of transitievergoeding</li>
                <li class="list">VUT-, AOW-, Anw-, WW-, WAO-, WIA- (WGA- of IVA-uitkering), Waz-, IOAW-, en IOAZ-uitkeringen</li>
                <li class="list">ziektewet-, WAZO- of geboorteverlofuitkeringen als deze door het UWV aan de werknemer zijn
                    uitbetaald. Ontving de werknemer deze uitkeringen van de werkgever, dan vallen ze onder 'Inkomsten
                    uit
                    loondienst'.
                </li>
                <li class="list">uitkeringen Participatiewet (zoals bijstand en Tijdelijke Overbruggingsregeling Zelfstandige
                    Ondernemers (TOZO)).
                </li>
                <li class="list">uitkeringen Wet arbeidsongeschiktheidsvoorziening voor jonggehandicapten (Wajong)</li>
                <li class="list">andere uitkeringen door arbeidsongeschiktheid en uitkeringen uit verplichte
                    beroepspensioenregelingen
                </li>
                <li class="list">invaliditeitspensioen</li>
                <li class="list">bijzondere invaliditeitsverhoging (BIV) voor oud-militairen</li>
                <li class="list">partneralimentatie voor uzelf die de uitkeringsgerechtigde via de Sociale Dienst krijgt</li>
                <li class="list">premies voor werkaanvaarding</li>
                <li class="list">lijfrente-uitkeringen</li>
                <li class="list">afkoopsommen van lijfrente</li>
                <li class="list">afkoopsommen van pensioen</li>
                <li class="list">de afkoopsom van een stamrecht</li>
                <li class="list">periodieke uitkeringen (en afkoopsommen daarvan) uit een verzekering die de persoon zelf heeft
                    afgesloten voor invaliditeit, ziekte of een ongeval
                </li>
                <li class="list">bijzondere bijstand die iemand krijgt als aanvulling op het inkomen</li>

                <div class="space10"></div>
                Vul een en ander hier ook in als iemand een uitkering heeft terugbetaald en dit als negatief inkomen mag
                verrekenen in de aangifte.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Wat valt er niet onder 'Pensioen en uitkeringen'
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De volgende inkomsten hoef je hier niet aan te geven:
                <li class="list">ontvangen bedragen op basis van een (voorlopige) aanslag inkomstenbelasting</li>
                <li class="list">stakingsuitkeringen van vakbonden</li>
                <li class="list">bijzondere bijstand, niet als aanvulling op je inkomen. Bijzondere bijstand is een vergoeding voor
                    noodzakelijke uitgaven die de persoon door bijzondere omstandigheden
                    niet kan betalen. Bijvoorbeeld als hij extra kosten hebt door ziekte.
                </li>
                <li class="list">huur-, zorg- en kinderopvangtoeslag en kindgebonden budget</li>
                <li class="list">studiefinanciering op basis van de Wet studiefinanciering 2000 (WSF 2000)</li>
                <li class="list">toelagen op basis van de Wet Tegemoetkoming Onderwijsbijdragen Schoolkosten (WTOS)</li>
                <li class="list">studieleningen</li>
                <li class="list">eenmalige studie-uitkeringen</li>
                <li class="list">periodieke studietoelagen (Wet studiefinanciering of Wet op het hoger onderwijs en
                    wetenschappelijk
                </li>
                <li class="list">onderzoek en uitkeringen of verstrekkingen uit het mbo-studentenfonds)</li>
                <li class="list">kinderbijslag</li>
                <li class="list">bestuursbeurs wegens bestuursactiviteiten studentenvereniging</li>
                <li class="list">een mantelzorgcompliment</li>
                <li class="list">uitkeringen en verstrekkingen op basis van de Regeling opvang asielzoekers of de Regeling
                    verstrekkingen asielzoekers en andere categorieën vreemdelingen 2005 (bijvoorbeeld uitbetaald
                    weekgeld aan asielzoekers)
                </li>
                <li class="list">uitkeringen van het UWV die gericht zijn op het verbeteren of behouden van een positie op de
                    arbeidsmarkt
                </li>
                <li class="list">uitkeringen aan joodse vervolgingsslachtoffers uit het Artikel 2-fonds</li>
                <li class="list">getto-uitkeringen of vergelijkbare uitkeringen die door Duitsland worden verstrekt in het kader van
                    de 'Wiedergutmachung'
                </li>
                <li class="list">Duitse DRV-uitkeringen voor dwangarbeiders tijdens de Tweede Wereldoorlog, als de persoon erkend is
                    als 'Verfolgte'
                </li>
                <li class="list">zorgbonus</li>
                <li class="list">uitkeringen en verstrekkingen aan ontheemden uit Oekraïne voor voedsel, kleding en andere
                    persoonlijke uitgaven.
                </li>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Pensioen of uitkering terugbetaald
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als je een uitkering ontvangt, betaalt je over die inkomsten belasting. Kreeg je
                een te hoge uitkering? Of kreeg je ten onrechte een uitkering? En moet je dit terugbetalen?
                Terugbetaling van deze te veel of ten onrechte ontvangen inkomsten noemen wij 'negatief loon'. Misschien
                krijg je de belasting terug die over de terugbetaalde inkomsten is ingehouden.
                <div class="space10"></div>

                De uitkeringsinstantie kan de terugbetaling op verschillende manieren verrekenen. Van
                belang is bijvoorbeeld of je het netto- of brutobedrag hebt terugbetaald. Vraag bij de
                uitkeringsinstantie na hoe de terugbetaling is verrekend.
                <div class="space10"></div>

                <b>Er zijn 2 manieren:</b><br/>
                <li class="list">de uitkeringsinstantie verrekende de terugbetaalde inkomsten met het bruto-uitkering. In dat geval hoef je niets te doen. Dit is verwerkt in de jaaropgaaf.
                </li>
                <li class="list">je betaalde (een deel van) de te veel of ten onrechte ontvangen inkomsten zelf terug
                    in {{ this.year }}. Dan kun je de belasting hierover terugvragen via de aangifte. Vermeld dat bedrag bij 'Pensioen
                    en andere uitkeringen'. Zet een minteken voor dit bedrag.
                </li>
                <div class="space10"></div>

                <b>Uitzonderingen</b><br/>
                Misschien hoef je de te veel of ten onrechte ontvangen inkomsten niet aan te geven. Daarvoor moet het
                voldoen aan de volgende voorwaarden:
                <li class="list">de persoon kreeg de uitkering niet te kwader trouw.</li>
                <li class="list">de persoon kan aantonen dat hij de te veel of ten onrechte ontvangen inkomsten helemaal hebt
                    terugbetaald.
                </li>
                <li class="list">de persoon heeft de terugbetaling van de ten onrechte ontvangen inkomsten in {{ this.year }} niet
                    afgetrokken van de uitkering. Of hij heeft dat wel gedaan en gaat akkoord met het corrigeren van die aftrek.
                    Gaat het om in eerste instantie terecht ontvangen uitkeringen die worden vervangen door andere
                    uitkeringen? Dan mag je de terugbetaling als negatief loon aangeven in het jaar waarin
                    de uitkering ontving is. Je moet dan wel voldoen aan de volgende voorwaarden:<br/>
                    - de persoon kreeg de uitkering niet te kwader trouw<br/>
                    - de persoon kan aantonen dat hij de teveel of ten onrechte ontvangen inkomsten helemaal heeft
                    terugbetaald.
                </li>
                <li class="list">de persoon betaalt de uitkering terug voor 1 april van het jaar nadat hij deze inkomsten
                    had. Of hij geeft voor deze datum door dat hij deze inkomsten later in dat jaar terugbetaalt.
                </li>
                <li class="list">de persoon gaat akkoord met het terugnemen van de aftrek als hij in een ander jaar de terugbetaalde
                    inkomsten heeft afgetrokken.
                </li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingRevisierente">
            <button aria-controls="collapseRevisierente" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseRevisierente" data-bs-toggle="collapse"
                    type="button">
                Afkoop lijfrente en revisierente
            </button>
        </h2>
        <div aria-labelledby="headingRevisierente" class="accordion-collapse collapse"
             data-bs-parent="#accordionRevisierente"
             id="collapseRevisierente">
            <div class="accordion-body">
                Kocht je een lijfrente af? Dan moet je in veel gevallen revisierente betalen. Deze bedraagt in dat geval 20% van het
                belaste deel van de afkoopsom. Dat is het bedrag van de afkoopsom verminderd met de niet-afgetrokken premies
                of stortingen. Voor de jaren vanaf 2010 mag je daarbij maximaal € 2.269 per kalenderjaar
                meetellen. Voor de jaren t/m 2009 mag je alle premies die je nog niet hebt afgetrokken, meetellen.
                <br/><br/>
                <b>Invullen in de aangifte</b><br/>
                In Snelstart Fiscaal kun je de revisierente invullen bij 'Overige inkomsten > Periodieke uitkeringen'.

                <br/><br/>
                Heb je een 'verklaring niet-afgetrokken premies of bedragen' (saldoverklaring) aan de financiële
                instelling gestuurd voordat de afkoopsom werd uitgekeerd? Dan zal de financiële instelling al
                rekening gehouden hebben met de saldomethode. De revisierente bedraagt dan 20% van het bedrag
                van de jaaropgaaf van jouw financiële instelling.
                <br/><br/>
                Koop je de lijfrente af binnen 10 jaar na het einde van het kalenderjaar waarin je de lijfrente
                hebt afgesloten? Dan kan het zijn dat de revisierente lager is. Je berekent dat zelf met de
                <a href="https://www.belastingdienst.nl/wps/wcm/connect/nl/werk-en-inkomen/content/hulpmiddel-revisierente-berekenen"
                   target="_blank">Rekenhulp Revisierente</a> op belastingdienst.nl. Als het berekende bedrag lager is
                dan 20% van het aangegeven bedrag, vul je het lagere bedrag in.
                <br/><br/>
                In de volgende gevallen ben je geen revisierente verschuldigd. Vul dan een '0' in:
                <ul>
                    <li>Je hebt een lijfrente afgesloten vóór 16 oktober 1990. De premie mag daarna niet zijn
                        verhoogd, behalve als dat mogelijk was door een clausule in die polis.
                    </li>
                    <li>Je hebt een lijfrente afgesloten op 16 oktober 1990 of later, maar uiterlijk 31 december
                        1991. Er mag geen premie meer betaald zijn na 31 december 1991.
                    </li>
                    <li>De afkoopregeling kleine lijfrenten is van toepassing. Lees meer hierover in de fiscale
                        informatie van de Belastingdienst (zie onder).</li>
                    <li>Je koopt de lijfrente geheel of gedeeltelijk af vanwege arbeidsongeschiktheid.</li>
                </ul>
                <strong>Let op!</strong> Is jouw oud-regime-lijfrente aangepast aan de voorwaarden voor
                premieaftrek onder de Wet inkomstenbelasting 2001? En koop je dat deel van de
                lijfrenteverzekering af? Dan moet je over de afkoopsom van dat deel wél revisierente betalen.
                <br/><br/>
                <strong>Let op!</strong> Kocht je een lijfrente af vanwege arbeidsongeschiktheid en ontving je
                een hoger bedrag dan het voor jou geldende maximum? Dan ben je over dat hogere bedrag
                revisierente verschuldigd. Bereken de revisierente alleen over de afkoopsom min het voor jou
                geldende maximumbedrag.
            </div>
        </div>
    </div>

</div>

